<div class="tanevvalto">

  <ion-card>
    <ion-card-header>
      <ion-card-title>Tanévváltás és -előkészítés</ion-card-title>
      <ion-card-subtitle>
        Itt hozod létre a következő tanévet, léptetheted az osztályokat, majd ha kész,
        megnyitod. Az <b>előkészítés alatt</b> álló tanévbe már tölthetsz adatot, de
        értékelés nem írható rá, és a mostani tanév felületein nem jelenik meg.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-note color="warning" *ngIf="!jogosult" style="display:block;margin-bottom:10px">
        Ez a menüpont csak admin jogosultsággal használható.
      </ion-note>

      <!-- Munkatanév-váltó -->
      <ion-item lines="full" class="munkatanev-sor">
        <ion-select label="Munkatanév" label-placement="stacked" interface="popover"
                    [value]="munkatanev" (ionChange)="munkatanevValt($event.detail.value)">
          <ion-select-option *ngFor="let t of tanevek" [value]="t.id">
            {{ t.name }} – {{ statuszNev(t.statusz) }}{{ t.id === aktualistanev ? ' (aktuális)' : '' }}
          </ion-select-option>
        </ion-select>
        <ion-badge slot="end" [color]="munkatanev === aktualistanev ? 'success' : 'warning'">
          {{ munkatanev === aktualistanev ? 'aktuális tanéven dolgozol' : 'előkészített tanéven dolgozol' }}
        </ion-badge>
      </ion-item>
      <ion-note color="medium" class="magyarazat">
        A munkatanév csak a törzsadat-felületekre hat (osztályok, csoportok, tantárgyfelosztás,
        tantermek). A napló, az értékelés és a hiányzás mindig az <b>aktuális</b> tanévre megy.
      </ion-note>

      <!-- Intézményi tanév-beállítások: eddig a Törzsadat-szerkesztő „Feladatellátási helyek"
           tábláján, nyers mezőként voltak; innentől itt, a tanévekkel egy helyen. -->
      <ion-item lines="full">
        <ion-input label="Intézmény első tanéve" label-placement="stacked" type="number"
                   [(ngModel)]="elsotanev" [disabled]="!jogosult"></ion-input>
        <ion-button slot="end" size="small" fill="outline"
                    [disabled]="!jogosult || elsotanevMentes" (click)="mentElsotanev()">
          Mentés
        </ion-button>
      </ion-item>
      <ion-note color="medium" class="magyarazat">
        Az <b>aktuális tanévet</b> nem itt kell állítani: azt a kártyáknál lévő
        <b>Megnyitás</b> gomb írja át, hogy a lezárás is megtörténjen. A tanév kezdő-,
        félévi és záró dátuma alább, tanévenként szerkeszthető – ezeket használja a napló,
        az órarend, a hiányzás-összesítő és a bizonyítvány is.
      </ion-note>

      <div *ngIf="betoltes" class="ion-text-center ion-padding">
        <ion-spinner name="crescent"></ion-spinner>
      </div>

      <!-- Tanév-kártyák -->
      <div class="tanev-lista" *ngIf="!betoltes">
        <div class="tanev-kartya" *ngFor="let t of tanevek" [class.aktualis]="t.id === aktualistanev">
          <div class="tanev-fej">
            <div>
              <h2>{{ t.name }}</h2>
              <ion-badge [color]="statuszSzine(t.statusz)">{{ statuszNev(t.statusz) }}</ion-badge>
              <ion-badge color="primary" *ngIf="t.id === aktualistanev">aktuális tanév</ion-badge>
            </div>
          </div>

          <div class="tanev-datumok">
            <ion-input label="Tanévkezdés" label-placement="stacked" type="date"
                       [(ngModel)]="t.tankezd" [disabled]="!jogosult"></ion-input>
            <ion-input label="Félév" label-placement="stacked" type="date"
                       [(ngModel)]="t.felev" [disabled]="!jogosult"></ion-input>
            <ion-input label="Tanév vége" label-placement="stacked" type="date"
                       [(ngModel)]="t.tanvege" [disabled]="!jogosult"></ion-input>
            <ion-button size="small" fill="outline" [disabled]="!jogosult" (click)="mentDatumok(t)">
              Mentés
            </ion-button>
          </div>

          <div class="tanev-szamlalok">
            <span>Osztály: <b>{{ t.szamlalok?.osztaly || 0 }}</b></span>
            <span>Tanuló: <b>{{ t.szamlalok?.tanulo || 0 }}</b></span>
            <span>Tantárgy: <b>{{ t.szamlalok?.tantargy || 0 }}</b></span>
            <span>Kerettanterv: <b>{{ t.szamlalok?.kerettanterv || 0 }}</b></span>
            <span>Csoport: <b>{{ t.szamlalok?.csoport || 0 }}</b></span>
            <span>TTF sor: <b>{{ t.szamlalok?.ttf || 0 }}</b><b class="arva" *ngIf="t.szamlalok?.ttf_arva">
              ({{ t.szamlalok.ttf_arva }} árva – hiányzó kerettanterv)</b></span>
            <span>Terem: <b>{{ t.szamlalok?.terem || 0 }}</b></span>
            <span>Csengetés: <b>{{ t.szamlalok?.csengetes || 0 }}</b></span>
          </div>

          <div class="tanev-gombok" *ngIf="jogosult">
            <ion-button size="small" fill="outline" (click)="elokeszitesNyit(t)"
                        *ngIf="t.statusz === 'elokeszites'">
              <ion-icon slot="start" name="construct-outline"></ion-icon>Előkészítés
            </ion-button>
            <ion-button size="small" color="success" (click)="megnyitas(t)"
                        *ngIf="t.id !== aktualistanev">
              <ion-icon slot="start" name="lock-open-outline"></ion-icon>Megnyitás (ez legyen az aktuális)
            </ion-button>
            <ion-button size="small" color="medium" (click)="lezaras(t)"
                        *ngIf="t.statusz !== 'lezart' && t.id !== aktualistanev">
              <ion-icon slot="start" name="lock-closed-outline"></ion-icon>Lezárás
            </ion-button>
            <ion-button size="small" fill="outline" color="tertiary" (click)="ujranyitas(t)"
                        *ngIf="t.statusz === 'lezart'">
              <ion-icon slot="start" name="refresh-outline"></ion-icon>Újranyitás (javításhoz)
            </ion-button>
            <!-- Tévedésből aktív/lezárt státusszal létrejött tanév visszatétele, hogy
                 az Előkészítés (osztályléptetés) és a törlés újra elérhető legyen. -->
            <ion-button size="small" fill="outline" color="warning" (click)="elokeszitesbe(t)"
                        *ngIf="t.statusz !== 'elokeszites' && t.id !== aktualistanev">
              <ion-icon slot="start" name="construct-outline"></ion-icon>Vissza előkészítésbe
            </ion-button>
            <ion-button size="small" fill="clear" color="danger" (click)="torles(t)"
                        *ngIf="t.id !== aktualistanev">
              <ion-icon slot="start" name="trash-outline"></ion-icon>Tanév törlése
            </ion-button>
          </div>
        </div>

        <ion-note color="medium" *ngIf="!tanevek.length" class="ion-padding">
          Ehhez az intézményhez még nincs rögzített tanév.
        </ion-note>

        <!-- Az osztályléptető az „Előkészítés" gomb mögött van, az viszont csak
             előkészítés státuszú tanévnél jelenik meg – enélkül nem derül ki, mi a teendő. -->
        <ion-note color="warning" class="nincs-elokeszites"
                  *ngIf="tanevek.length && !vanElokeszites">
          <b>Nincs előkészítés alatt álló tanév.</b>
          Az <b>osztályok léptetése</b> (átsorolás), a tanulók átléptetése és a törzsadat
          átemelése az <b>Előkészítés</b> gomb mögött van, az viszont csak olyan tanévnél
          jelenik meg, amelyik előkészítés alatt áll. Kattints lent az
          <b>„Új tanév létrehozása"</b> gombra – az új tanév automatikusan előkészítés
          státusszal jön létre, és a kártyáján rögtön ott lesz az <b>Előkészítés</b> gomb.
        </ion-note>
      </div>

      <!-- Új tanév -->
      <div class="uj-tanev" *ngIf="jogosult">
        <ion-button size="small" fill="outline" (click)="ujForm = !ujForm">
          <ion-icon slot="start" [name]="ujForm ? 'close-outline' : 'add-outline'"></ion-icon>
          {{ ujForm ? 'Mégse' : 'Új tanév létrehozása' }}
        </ion-button>

        <div class="uj-tanev-form" *ngIf="ujForm">
          <ion-input label="Tanév (kezdő évszám)" label-placement="stacked" type="number"
                     [(ngModel)]="uj.id"></ion-input>
          <ion-input label="Megnevezés" label-placement="stacked" [(ngModel)]="uj.name"></ion-input>
          <ion-input label="Tanévkezdés" label-placement="stacked" type="date" [(ngModel)]="uj.tankezd"></ion-input>
          <ion-input label="Félév" label-placement="stacked" type="date" [(ngModel)]="uj.felev"></ion-input>
          <ion-input label="Tanév vége" label-placement="stacked" type="date" [(ngModel)]="uj.tanvege"></ion-input>
          <ion-button size="small" (click)="ujTanev()" [disabled]="ujFolyamatban">
            <ion-icon slot="start" name="save-outline"></ion-icon>Létrehozás (előkészítés státusszal)
          </ion-button>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- ── Előkészítő varázsló ── -->
  <ion-card *ngIf="elokeszitendo">
    <ion-card-header>
      <ion-card-title>{{ elokeszitendo.name }} előkészítése</ion-card-title>
      <ion-card-subtitle>
        Az adatok átemelése a forrás tanévből. A művelet <b>többször is futtatható</b>:
        ami már létezik a cél tanévben, azt nem hozza létre újra.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-item lines="full">
        <ion-select label="Forrás tanév" label-placement="stacked" interface="popover"
                    [value]="forrasEv" (ionChange)="forrasEv = $event.detail.value; tervBetoltes()">
          <ion-select-option *ngFor="let t of tanevek" [value]="t.id"
                             [disabled]="t.id === elokeszitendo.id">
            {{ t.name }}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <div *ngIf="tervBetolt" class="ion-text-center ion-padding">
        <ion-spinner name="crescent"></ion-spinner>
      </div>

      <ng-container *ngIf="terv && !tervBetolt">
        <h3>1. Mit emeljünk át a törzsadatból?</h3>
        <div class="opciok">
          <ion-item lines="none">
            <ion-checkbox slot="start" [checked]="opciok.tantargy"
                          (ionChange)="opciok.tantargy = $event.detail.checked"></ion-checkbox>
            <ion-label>Tantárgyak <small class="muted">({{ terv.masolhato?.tantargy || 0 }} db)</small></ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-checkbox slot="start" [checked]="opciok.kerettanterv"
                          (ionChange)="opciok.kerettanterv = $event.detail.checked"></ion-checkbox>
            <ion-label>Kerettanterv (óratervi óraszámok) <small class="muted">({{ terv.masolhato?.kerettanterv || 0 }} db)</small></ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-checkbox slot="start" [checked]="opciok.terem"
                          (ionChange)="opciok.terem = $event.detail.checked"></ion-checkbox>
            <ion-label>Tantermek <small class="muted">({{ terv.masolhato?.terem || 0 }} db)</small></ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-checkbox slot="start" [checked]="opciok.csengetes"
                          (ionChange)="opciok.csengetes = $event.detail.checked"></ion-checkbox>
            <ion-label>Csengetési rend <small class="muted">({{ terv.masolhato?.csengetes || 0 }} db)</small></ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-checkbox slot="start" [checked]="opciok.csoport"
                          (ionChange)="opciok.csoport = $event.detail.checked"></ion-checkbox>
            <ion-label>
              Csoportok (bontás) <small class="muted">({{ terv.masolhato?.csoport || 0 }} db)</small>
              <p class="muted">A csoport-osztály kötések csak a léptetett osztályokra jönnek át.</p>
            </ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-checkbox slot="start" [checked]="opciok.ttf"
                          (ionChange)="opciok.ttf = $event.detail.checked"></ion-checkbox>
            <ion-label>
              Tantárgyfelosztás (tanári beosztás) <small class="muted">({{ terv.masolhato?.ttf || 0 }} db)</small>
              <p class="muted">Kiindulásnak jó, utána a TTF felületén szerkeszthető.</p>
            </ion-label>
          </ion-item>
        </div>

        <h3>2. Osztályok léptetése</h3>
        <p class="muted magyarazat">
          Az új osztálynév automatikus javaslat (az első számot lépteti), de szabadon átírható.
          A legmagasabb évfolyam alapból <b>végzős</b>: nem lép tovább, helyette a tanulói
          jogviszonya a forrás tanév végével lezárul (<b>Kiléptetés</b>).
        </p>
        <p class="muted magyarazat">
          <b>Az előző tanév adatai változatlanok maradnak.</b> A léptetés mindig ÚJ osztályt hoz
          létre az új tanévre, és a diákoknak ÚJ besorolást ad – a régi osztály, a névsora, a
          jegyek és a hiányzások érintetlenül visszanézhetők. A régi besorolásokon csak a
          záró dátum kerül kitöltésre (ami eddig nyitva volt), hogy egy tanuló ne legyen
          egyszerre két osztályban.
        </p>
        <div class="leptet-gombok">
          <ion-button size="small" fill="outline" (click)="mindLeptet(true)">Mind léptet</ion-button>
          <ion-button size="small" fill="outline" (click)="mindLeptet(false)">Egyik sem</ion-button>
        </div>

        <div class="scrollable">
          <table class="leptet-tabla">
            <thead>
              <tr>
                <th>Léptet</th>
                <th>Jelenlegi osztály</th>
                <th>Évf.</th>
                <th>Tanuló</th>
                <th>Új osztálynév</th>
                <th>Új évf.</th>
                <th>Tanulók átléptetése</th>
                <th>Kiléptetés<br><small>(jogviszony zárása)</small></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let o of terv.osztalyok" [class.vegzos]="o.vegzos">
                <td>
                  <ion-checkbox [checked]="o.leptet"
                                (ionChange)="leptetValt(o, $event.detail.checked)"></ion-checkbox>
                </td>
                <td>{{ o.forras_nev }}</td>
                <td>{{ o.forras_evfolyam }}</td>
                <td>{{ o.tanulo_db }}</td>
                <td><ion-input [(ngModel)]="o.uj_nev" [disabled]="!o.leptet"></ion-input></td>
                <td><ion-input type="number" [(ngModel)]="o.uj_evfolyam" [disabled]="!o.leptet"></ion-input></td>
                <td>
                  <ion-checkbox [checked]="o.tanulok" [disabled]="!o.leptet"
                                (ionChange)="o.tanulok = $event.detail.checked"></ion-checkbox>
                </td>
                <td>
                  <ion-checkbox [checked]="o.kileptet" [disabled]="o.leptet"
                                (ionChange)="o.kileptet = $event.detail.checked"></ion-checkbox>
                </td>
                <td>
                  <ion-badge color="medium" *ngIf="o.vegzos">végzős</ion-badge>
                  <ion-badge color="success" *ngIf="o.mar_letezik">már létezik</ion-badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="futtat">
        <!--  TÜKRÖZÉS – EGY KAPCSOLÓ A FENTI TÖRZSADATOKRA.
              Az átvétel alapból csak hozzáad, ezért ismételt futtatásnál a célév csak nő:
              ami a forrásévben már nincs meg, az itt bent marad. Külön-külön kapcsolgatva
              a felhasználónak kellene fejben tartania, melyik törzsadat maradt piszkos –
              pedig a kérdés egy: a forrás legyen-e a mérvadó. -->
        <div class="tukrozes-doboz">
          <ion-item lines="none">
            <ion-checkbox slot="start" [checked]="opciok.tukrozes"
                          (ionChange)="opciok.tukrozes = $event.detail.checked"></ion-checkbox>
            <ion-label class="ion-text-wrap">
              <b>A forrás legyen a mérvadó</b> — a célévből törlődjön, ami a forrásban már nincs
              <br><small class="muted">A fent kipipált törzsadatokra vonatkozik (tantárgy,
              óraterv, terem, csoport). Enélkül az átvétel csak hozzáad: minden futtatással
              nő a törzsadat, a megszűnt sorok bent maradnak.
              <b>Használatban lévő sort ez sem töröl</b> — amire óra, tantárgyfelosztás,
              tanmenet, értékelés vagy tanulói tagság hivatkozik, az megmarad, és a futás
              után tételesen felsoroljuk. Az <b>osztályok és a tanulói besorolások</b> soha
              nem törlődnek: azok léptetéssel keletkeznek, nem másolással.</small>
            </ion-label>
          </ion-item>
        </div>

          <ion-button (click)="elokeszitesFuttat()" [disabled]="elokeszitesFut || !jogosult">
            <ion-icon slot="start" name="play-outline"></ion-icon>
            {{ elokeszitesFut ? 'Fut…' : 'Előkészítés futtatása' }}
          </ion-button>
        </div>

        <div class="eredmeny" *ngIf="eredmeny">
          <b>Létrejött:</b>
          tantárgy {{ eredmeny.tantargy }} ·
          kerettanterv {{ eredmeny.kerettanterv }} ·
          terem {{ eredmeny.terem }} ·
          csengetés {{ eredmeny.csengetes }} ·
          osztály {{ eredmeny.osztaly }} ·
          tanulói besorolás {{ eredmeny.tanulo }} ·
          kiléptetve {{ eredmeny.kileptetve }} ·
          csoport {{ eredmeny.csoport }} ·
          TTF sor {{ eredmeny.ttf }}<span *ngIf="eredmeny.ttf_kihagyva"> ·
          <b class="arva">{{ eredmeny.ttf_kihagyva }} TTF sor kihagyva (nincs óratervi sor az új évfolyamon)</b></span>
          <div *ngIf="eredmeny.tukrozes?.tipusok?.length" class="tukrozes-eredmeny">
            <b>Tükrözés:</b> {{ eredmeny.tukrozes.torolt }} sor törölve
            <span *ngIf="eredmeny.tukrozes.megtartott">·
              <b class="arva">{{ eredmeny.tukrozes.megtartott }} megtartva, mert használatban van</b>
            </span>
            <div *ngFor="let t of eredmeny.tukrozes.tipusok" style="margin-top:4px">
              <b>{{ t.cimke }}:</b> {{ t.torolt }} törölve<span *ngIf="t.megtartott">, {{ t.megtartott }} megtartva</span>
              <ul class="muted" *ngIf="t.lista?.length">
                <li *ngFor="let m of t.lista">{{ m.nev }} <small>({{ m.okok.join(', ') }})</small></li>
              </ul>
            </div>
          </div>
          <p class="muted">
            A 0 érték azt jelenti, hogy az adott elem már létezett a cél tanévben (nem duplikáltuk).
            Ha most szeretnél az új tanévben dolgozni, állítsd át fent a <b>munkatanévet</b>.
          </p>
        </div>
      </ng-container>
    </ion-card-content>
  </ion-card>
</div>
